import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import langEn from "../lang/en-us.js";
import { isSSR, fromSSR } from "./plugins/Platform.js";

function getLocale() {
  if (isSSR === true) {
    return;
  }

  var val = navigator.language || navigator.languages[0] || navigator.browserLanguage || navigator.userLanguage || navigator.systemLanguage;

  if (val) {
    return val.toLowerCase();
  }
}

export default {
  getLocale: getLocale,
  install: function install($q, queues, lang) {
    var _this = this;

    var initialLang = lang || langEn;

    this.set = function () {
      var langObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : langEn;
      var ssrContext = arguments.length > 1 ? arguments[1] : undefined;

      var lang = _objectSpread(_objectSpread({}, langObject), {}, {
        rtl: langObject.rtl === true,
        getLocale: getLocale
      });

      if (isSSR === true) {
        if (ssrContext === void 0) {
          console.error('SSR ERROR: second param required: Quasar.lang.set(lang, ssrContext)');
          return;
        }

        var dir = lang.rtl === true ? 'rtl' : 'ltr';
        var attrs = "lang=".concat(lang.isoName, " dir=").concat(dir);
        lang.set = ssrContext.$q.lang.set;
        ssrContext.Q_HTML_ATTRS = ssrContext.Q_PREV_LANG !== void 0 ? ssrContext.Q_HTML_ATTRS.replace(ssrContext.Q_PREV_LANG, attrs) : attrs;
        ssrContext.Q_PREV_LANG = attrs;
        ssrContext.$q.lang = lang;
      } else {
        if (fromSSR === false) {
          var el = document.documentElement;
          el.setAttribute('dir', lang.rtl === true ? 'rtl' : 'ltr');
          el.setAttribute('lang', lang.isoName);
        }

        lang.set = _this.set;
        $q.lang = _this.props = lang;
        _this.isoName = lang.isoName;
        _this.nativeName = lang.nativeName;
      }
    };

    if (isSSR === true) {
      queues.server.push(function (q, ctx) {
        q.lang = {};

        q.lang.set = function (langObject) {
          _this.set(langObject, ctx.ssr);
        };

        q.lang.set(initialLang);
      });
      this.isoName = initialLang.isoName;
      this.nativeName = initialLang.nativeName;
      this.props = initialLang;
    } else {
      Vue.util.defineReactive($q, 'lang', {});
      this.set(initialLang);
    }
  }
};